export default __webpack_public_path__ + "static/ozf-logo-f358143a25b7f1bf720159d39239aafe.png";